import React from "react";
import { motion } from "framer-motion";

export function StatCard({ icon: Icon, label, value, sub, tone = "blue", index = 0, testId }) {
  const tones = {
    blue: "bg-teal-50 text-teal-700",
    emerald: "bg-emerald-50 text-emerald-700",
    amber: "bg-amber-50 text-amber-700",
    rose: "bg-rose-50 text-rose-700",
    indigo: "bg-indigo-50 text-indigo-700",
    slate: "bg-slate-100 text-slate-700",
  };
  return (
    <motion.div
      data-testid={testId}
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.05 }}
      className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm transition-shadow hover:shadow-md"
    >
      <div className="flex items-center justify-between">
        <div className={`flex h-10 w-10 items-center justify-center rounded-lg ${tones[tone]}`}>
          {Icon && <Icon className="h-5 w-5" />}
        </div>
        {sub && <span className="text-xs font-medium text-slate-400">{sub}</span>}
      </div>
      <div className="mt-4 font-display text-3xl font-extrabold tracking-tight text-slate-900">{value}</div>
      <div className="mt-1 text-xs font-medium uppercase tracking-wider text-slate-500">{label}</div>
    </motion.div>
  );
}
